import React, { useEffect, useState } from 'react';
import { AddressSuggestions } from "react-dadata";
import { FioSuggestions } from 'react-dadata';
import { InputMask } from 'primereact/inputmask';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import burger_2 from '../../static/img/burger-2.png'

import { useDispatch, useSelector } from 'react-redux';
import { selectCalcPage, setShowPopUpManager } from './homeSlice';
import { selectName, selectRegAdr, setName, setRegAdr } from '../calc/personSlice';
import { selectPhone, setPhone } from '../calc/calcSlice';
import { sendToManager } from './homeApi';

export function FormWait(props) {
    const dispatch = useDispatch()

    const [showMessengerSelecter, setShowMessengerSelecter] = useState(false);
    const [messenegr, setMessenegr] = useState('');
    const [comment, setComment] = useState('');

    const regAdr = useSelector(selectRegAdr)
    const name = useSelector(selectName)
    const phone = useSelector(selectPhone)
    const [stringDateBegin, setStringDateBegin] = useState('')
    
    

    const handleManager = () => {
        props.setShow(false)
        dispatch(setShowPopUpManager(true))
    }

    const handleAgain = () => {
        props.setShow(false)
    }

    return (
        <>
            <div class="b-popup" id="popup">
                    <div class="b-popup-vnutr"></div>
                    <div class="b-popup-content">
                        <p class="popup-title">Сбой</p>
                        <form class="form-popup">
                        <div class="one-ryad one-ryad-popup one-ryad-popup-2">
                                <label for="select-1">Во время рассчета стоимости произошел сбой,
                        вы можете запросить повторно цену или обратиться к менеджжеру</label>
                                {/* <input class="pole-popup pole-popup-1" name="Имя" type="text" placeholder="" required /> */}
                                
                            </div>
                            
                            <button onClick={handleManager} class="button button-1 button-popup-1 mt-10">Обратиться к менеджжеру</button>
                            <button onClick={handleAgain} class="button button-1 button-popup-1 mt-10">Запросить повторно</button>
                        </form>
                        <div onClick={() => props.setShow(false)} class="popup-close" ><img src={burger_2} alt="close" /></div>
                    </div>
                </div>
        </>
    );
}



